import { BaseService } from '@/core/base-service';
import axios from 'axios';

export default class MethodService extends BaseService<any> {
  public constructor() {
    super('services/serviceauttech/api/method');
  }

  public getOptions(): Promise<any> {
    return axios.get(this.endpointName + '/combobox');
  }
}
